import { Subject } from 'rxjs';
import { Injectable } from "@angular/core";

@Injectable()
export class MenuEntriesService {
    actionSub = new Subject();

    constructor() { }
}

export enum MenuActions{
    SHOW_MAP,
    QR_SCAN,
    EVENT_MARK,
    ADD_CALENDAR,
    INSTA_SHARE,
    FB_SHARE
}

export enum MenuModes{
    EVENT_DETAILS,
    PRIVATE,
    PUBLIC
}


// WEBPACK FOOTER //
// /src/providers/menu-entries.service.ts